export var ApplicationCommandOptionType;
(function (ApplicationCommandOptionType) {
    ApplicationCommandOptionType[ApplicationCommandOptionType["SUB_COMMAND_GROUP"] = 2] = "SUB_COMMAND_GROUP";
    ApplicationCommandOptionType[ApplicationCommandOptionType["SUB_COMMAND"] = 1] = "SUB_COMMAND";
    ApplicationCommandOptionType[ApplicationCommandOptionType["STRING"] = 3] = "STRING";
    ApplicationCommandOptionType[ApplicationCommandOptionType["NUMBER"] = 10] = "NUMBER";
    ApplicationCommandOptionType[ApplicationCommandOptionType["BOOLEAN"] = 5] = "BOOLEAN";
    ApplicationCommandOptionType[ApplicationCommandOptionType["USER"] = 6] = "USER";
    ApplicationCommandOptionType[ApplicationCommandOptionType["CHANNEL"] = 7] = "CHANNEL";
    ApplicationCommandOptionType[ApplicationCommandOptionType["ROLE"] = 8] = "ROLE";
    ApplicationCommandOptionType[ApplicationCommandOptionType["INTEGER"] = 4] = "INTEGER";
    ApplicationCommandOptionType[ApplicationCommandOptionType["ATTACHMENT"] = 11] = "ATTACHMENT";
    ApplicationCommandOptionType[ApplicationCommandOptionType["MENTIONABLE"] = 9] = "MENTIONABLE";
})(ApplicationCommandOptionType || (ApplicationCommandOptionType = {}));
export var ChannelType;
(function (ChannelType) {
    ChannelType[ChannelType["GUILD_TEXT"] = 0] = "GUILD_TEXT";
    ChannelType[ChannelType["DM"] = 1] = "DM";
    ChannelType[ChannelType["GUILD_VOICE"] = 2] = "GUILD_VOICE";
    ChannelType[ChannelType["GROUP_DM"] = 3] = "GROUP_DM";
    ChannelType[ChannelType["GUILD_CATEGORY"] = 4] = "GUILD_CATEGORY";
    ChannelType[ChannelType["GUILD_NEWS"] = 5] = "GUILD_NEWS";
    ChannelType[ChannelType["GUILD_NEWS_THREAD"] = 10] = "GUILD_NEWS_THREAD";
    ChannelType[ChannelType["GUILD_PUBLIC_THREAD"] = 11] = "GUILD_PUBLIC_THREAD";
    ChannelType[ChannelType["GUILD_PRIVATE_THREAD"] = 12] = "GUILD_PRIVATE_THREAD";
    ChannelType[ChannelType["GUILD_STAGE_VOICE"] = 13] = "GUILD_STAGE_VOICE";
    ChannelType[ChannelType["GUILD_DIRECTORY"] = 14] = "GUILD_DIRECTORY";
    ChannelType[ChannelType["GUILD_FORUM"] = 15] = "GUILD_FORUM";
})(ChannelType || (ChannelType = {}));
export var Locale;
(function (Locale) {
    Locale["Danish"] = "da";
    Locale["German"] = "de";
    Locale["English_UK"] = "en-GB";
    Locale["English_US"] = "en-US";
    Locale["Spanish"] = "es-ES";
    Locale["French"] = "fr";
    Locale["Croatian"] = "hr";
    Locale["Italian"] = "it";
    Locale["Lithuanian"] = "lt";
    Locale["Hungarian"] = "hu";
    Locale["Dutch"] = "nl";
    Locale["Norwegian"] = "no";
    Locale["Polish"] = "pl";
    Locale["Portuguese_Brazilian"] = "pt-BR";
    Locale["Romanian"] = "ro";
    Locale["Finnish"] = "fi";
    Locale["Swedish"] = "sv-SE";
    Locale["Vietnamese"] = "vi";
    Locale["Turkish"] = "tr";
    Locale["Czech"] = "cs";
    Locale["Greek"] = "el";
    Locale["Bulgarian"] = "bg";
    Locale["Russian"] = "ru";
    Locale["Ukrainian"] = "uk";
    Locale["Hindi"] = "hi";
    Locale["Thai"] = "th";
    Locale["Chinese_China"] = "zh-CN";
    Locale["Japanese"] = "ja";
    Locale["Chinese_Taiwan"] = "zh-TW";
    Locale["Korean"] = "ko";
})(Locale || (Locale = {}));
export var ApplicationCommandType;
(function (ApplicationCommandType) {
    ApplicationCommandType[ApplicationCommandType["CHAT_INPUT"] = 1] = "CHAT_INPUT";
    ApplicationCommandType[ApplicationCommandType["USER"] = 2] = "USER";
    ApplicationCommandType[ApplicationCommandType["MESSAGE"] = 3] = "MESSAGE";
})(ApplicationCommandType || (ApplicationCommandType = {}));
export var Permissions;
(function (Permissions) {
    Permissions["CREATE_INSTANT_INVITE"] = "CreateInstantInvite";
    Permissions["KICK_MEMBERS"] = "KickMembers";
    Permissions["BAN_MEMBERS"] = "BanMembers";
    Permissions["ADMINISTRATOR"] = "Administrator";
    Permissions["MANAGE_CHANNELS"] = "ManageChannels";
    Permissions["MANAGE_GUILD"] = "ManageGuild";
    Permissions["ADD_REACTIONS"] = "AddReactions";
    Permissions["VIEW_AUDIT_LOG"] = "ViewAuditLog";
    Permissions["PRIORITY_SPEAKER"] = "PrioritySpeaker";
    Permissions["STREAM"] = "Stream";
    Permissions["VIEW_CHANNEL"] = "ViewChannel";
    Permissions["SEND_MESSAGES"] = "SendMessages";
    Permissions["SEND_TTS_MESSAGES"] = " SendTTSMessages";
    Permissions["MANAGE_MESSAGES"] = "ManageMessages";
    Permissions["EMBED_LINKS"] = "EmbedLinks";
    Permissions["ATTACH_FILES"] = "AttachFiles";
    Permissions["READ_MESSAGE_HISTORY"] = "ReadMessageHistory";
    Permissions["MENTION_EVERYONE"] = "MentionEveryone";
    Permissions["USE_EXTERNAL_EMOJIS"] = "UseExternalEmojis";
    Permissions["VIEW_GUILD_INSIGHTS"] = "ViewGuildInsights";
    Permissions["CONNECT"] = "Connect";
    Permissions["SPEAK"] = "Speak";
    Permissions["MUTE_MEMBERS"] = "MuteMembers";
    Permissions["DEAFEN_MEMBERS"] = "DeafenMembers";
    Permissions["MOVE_MEMBERS"] = "MoveMembers";
    Permissions["USE_VAD"] = "UseVAD";
    Permissions["CHANGE_NICKNAME"] = "ChangeNickname";
    Permissions["MANAGE_NICKNAMES"] = "ManageNicknames";
    Permissions["MANAGE_ROLES"] = "ManageRoles";
    Permissions["MANAGE_WEBHOOKS"] = "ManageWebhooks";
    Permissions["MANAGE_EMOJIS_AND_STICKERS"] = "ManageGuildExpressions";
    Permissions["USE_APPLICATION_COMMANDS"] = "UseApplicationCommands";
    Permissions["REQUEST_TO_SPEAK"] = "RequestToSpeak";
    Permissions["MANAGE_EVENTS"] = "ManageEvents";
    Permissions["MANAGE_THREADS"] = "ManageThreads";
    Permissions["CREATE_PUBLIC_THREADS"] = "CreatePublicThreads";
    Permissions["CREATE_PRIVATE_THREADS"] = "CreatePrivateThreads";
    Permissions["USE_EXTERNAL_STICKERS"] = "UseExternalStickers";
    Permissions["SEND_MESSAGES_IN_THREADS"] = "SendMessagesInThreads";
    Permissions["USE_EMBEDDED_ACTIVITIES"] = "UseEmbeddedActivities";
    Permissions["MODERATE_MEMBERS"] = "ModerateMembers";
    Permissions["VIEW_CREATOR_MONETIZATION_ANALYTICS"] = "ViewCreatorMonetizationAnalytics";
    Permissions["USE_SOUNDBOARD"] = "UseSoundboard";
    Permissions["CREATE_GUILD_EXPRESSIONS"] = "CreateGuildExpressions";
    Permissions["CREATE_EVENTS"] = "CreateEvents";
    Permissions["USE_EXTERNAL_SOUNDS"] = "UseExternalSounds";
    Permissions["SEND_VOICE_MESSAGES"] = " SendVoiceMessages";
})(Permissions || (Permissions = {}));
